import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useResourcesContext } from '../resource/ResourceContext';
import { pushUserReady } from './gtmHelper';

const MAP_PATHS = ['/visits/map', '/clients/map'];

export default function UserReadyRouteListener() {
  const location = useLocation();
  const { loggedInUserInfo, setHideLeftMenu } = useResourcesContext();

  useEffect(() => {
    setHideLeftMenu(MAP_PATHS.includes(location.pathname));
  }, [location.pathname, setHideLeftMenu]);

  useEffect(() => {
    if (!loggedInUserInfo?.id) {
      return;
    }

    pushUserReady(loggedInUserInfo);
  }, [location.pathname, loggedInUserInfo]);

  return <Outlet />;
}
